<div class="login container bg-cinza-dbmax d-flex flex-column justify-content-center h-100 p-2">
  <div class="form-container">
    <div class="logo text-center">
      <img class="w-75" src="assets/logo-branco.png" />
    </div>
    <div class="card-body">
      <form [formGroup]="esqueciForm" (submit)="submit()">
        <p class="text-white">Digite seu e-mail de cadastro abaixo e clique em ENVIAR, para receber um e-mail de troca de senha.</p>
        <mat-form-field  class="w-100">
          <mat-label>E-mail</mat-label>
          <input formControlName="email" matInput type="email">
        </mat-form-field>
        <div *ngIf="mensagem" class='alert alert-danger'>
          {{mensagem}}
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-action-dbmax w-50 mb-3" >ENVIAR</button> <br />
          <button routerLink="/" *ngIf="enviado" type="submit" class="btn btn-action-dbmax w-50 mb-3" >VOLTAR</button> <br />
        </div>
      </form>
    </div>
  </div>
</div>
